"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ItemNotFoundError = exports.UnauthorizedError = exports.ValidationError = exports.HTTPError = void 0;
class HTTPError extends Error {
    constructor() {
        super();
        this.statusCode = 500;
        this.name = 'HTTPError';
        this.message = '';
        Object.setPrototypeOf(this, new.target.prototype);
    }
}
exports.HTTPError = HTTPError;
class ValidationError extends HTTPError {
    constructor(message) {
        super();
        this.statusCode = 400;
        this.name = 'ValidationError';
        this.message = message || 'Missing or invalid value(s) provided.';
    }
}
exports.ValidationError = ValidationError;
class UnauthorizedError extends HTTPError {
    constructor(message) {
        super();
        this.statusCode = 401;
        this.name = 'UnauthorizedError';
        this.message = message || 'Missing authentication.';
    }
}
exports.UnauthorizedError = UnauthorizedError;
class ItemNotFoundError extends HTTPError {
    constructor(message) {
        super();
        this.statusCode = 404;
        this.name = 'ItemNotFoundError';
        this.message = message || 'Requested DGA could not be found.';
    }
}
exports.ItemNotFoundError = ItemNotFoundError;
